<template>
  <div class="user-list">
    <div class="search-bar">
      <el-input v-model="searchParam.keyword_search" placeholder="输入名称" clearable @clear="getList"></el-input>
      <el-select v-model="searchParam.status" clearable @clear="getList">
        <el-option value="2" label="上架"></el-option>
        <el-option value="1" label="隐藏"></el-option>
      </el-select>
      <el-cascader
        placeholder="请选择类别"
        :options="options"
        :props="{ checkStrictly: true, label: 'name', value: 'id' }"
        clearable
        @change="changeOption"
      ></el-cascader>
      <el-button type="primary" @click="getList('clear')">查询</el-button>
      <el-button v-if="isteacher" type="primary" @click="addbox = true">新增考卷</el-button>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="title" label="标题" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="course_name" label="关联课程" width="120px"> </el-table-column>
        <el-table-column prop="section_name" label="关联课节" width="120px">
          <template slot-scope="scope">
            <span>
              {{ scope.row.paper_type == 2 ? "终考" : scope.row.section_name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="submit_pepole" label="填写人数" width="120px"> </el-table-column>
        <el-table-column label="创建人" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.admin">
              {{ scope.row.admin.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="是否显示" width="120px">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="2"
              :inactive-value="1"
              active-color="#13ce66"
              inactive-color="#999"
              :disabled="!isteacher"
              @change="changeStatus(scope.row, $event)"
            >
            </el-switch> </template
        ></el-table-column>

        <el-table-column prop="create_time" label="创建时间"> </el-table-column>

        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toTopic(scope.row)">题目</el-button>
            <el-button class="mid-blue" @click="toDetail(scope.row)">记录</el-button>
            <el-button v-if="isteacher" class="mid-blue" @click="editRow(scope.row)">编辑</el-button>
            <el-button v-if="isteacher" class="mid-red" @click="delItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="form.uuid ? '编辑考卷' : '添加考卷'" :visible.sync="addbox" center :before-close="closeForm">
      <el-form ref="ruleForm" :model="form" label-position="left" :rules="rules" label-width="100px" class="add-form">
        <el-form-item label="考卷名称" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="考卷分类" prop="paper_cate_id">
          <el-cascader
            v-model="form.paper_cate_id"
            placeholder="请选择类别"
            :options="options"
            :props="{
              checkStrictly: true,
              label: 'name',
              value: 'id',
            }"
            clearable
            @change="changeOption2"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="考试类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择考试类型">
            <el-option label="理论课" :value="1"></el-option>
            <el-option label="实践课" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面上传" prop="avatar">
          <imgUpload v-model="form.avatar"> </imgUpload>
        </el-form-item>
        <el-form-item label="考卷类型" prop="paper_type">
          <el-select v-model="form.paper_type" placeholder="请选择考卷类型">
            <el-option label="普通试卷" :value="1"></el-option>
            <el-option label="终考" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="考试说明" prop="detail">
          <el-input v-model="form.detail" type="textarea" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="list_order">
          <el-input v-model="form.list_order"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="subForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTeacherList } from "@/api/teacher.js";
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import { paperList, addPaper, editPaper, paperDetail, delPaper, paperStatus, paperCateList } from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";
import Utils from "@/jslibs/utils";
export default {
  components: {
    imgUpload,
  },
  mixins: [mixin],
  data() {
    return {
      addbox: false,
      form: { exam_type: 1, paper_cate_id: "" },
      ruleForm: {},
      rules: {
        title: [
          {
            required: true,
            message: "请输入考试名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择考试类型",
            trigger: "change",
          },
        ],
        avatar: [
          {
            required: true,
            message: "请上传考试封面",
            trigger: "change",
          },
        ],
        paper_type: [
          {
            required: true,
            message: "请选择考卷类型",
            trigger: "change",
          },
        ],
        detail: [
          {
            required: true,
            message: "请填写考试说明",
            trigger: "change",
          },
        ],
        paper_cate_id: [
          {
            required: true,
            message: "请选择考试类别",
            trigger: "change",
          },
        ],
        // list_order: [{ type: 'number', min: 0, message: '请输入正确的排序', trigger: 'blur' }]
      },
      loading: false,
      teacherList: [],
      searchParam: {
        keyword_search: "",

        start_time: "",
        end_time: "",
      },
      tableData: [],
      options: [],
      paper_cate_id: "",
    };
  },
  computed: {
    isteacher() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 927 && g != 952;
    },
  },
  mounted() {
    this.getList();
    this.getListCates();
  },
  methods: {
    changeOption(e) {
      console.log(e);
      console.log(e.length);
      if (e.length === 0) {
        this.paper_cate_id = "";
        return;
      }
      this.paper_cate_id = e[e.length - 1];
      console.log(this.paper_cate_id);
    },
    changeOption2(e) {
      console.log(e);
      console.log(e.length);
      if (e.length === 0) {
        this.form.paper_cate_id = "";
        return;
      }
      this.form.paper_cate_id = e[e.length - 1];
      console.log(this.paper_cate_id);
    },
    async getListCates() {
      const param = {
        is_filter: 1,
      };
      this.loading = true;
      const res = await paperCateList(param);
      console.log(res, "sdfsdf");
      this.options = res;
      this.loading = false;
    },
    changeStatus(row, type) {
      paperStatus(row.uuid).then((res) => {
        if (res) {
          this.getList();
        }
      });
    },
    getTeacher(keyword_search) {
      getTeacherList({ keyword_search }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDistribution(row) {
      console.log(row);
      this.$router.push({
        path: "/distribution",
        query: row,
      });
    },
    toTopic(row) {
      console.log(row);
      this.$router.push({
        path: "/paper-subject",
        query: row,
      });
      // this.$router.push({
      //     path: '/online-topic',
      //     query: row
      // })
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/topic-record",
        query: row,
      });
    },

    setTop(row) {},
    xiajia(row) {},
    agree() {},
    closeForm() {
      this.form = { exam_type: 1 };
      this.addbox = false;
    },
    editRow(row) {
      paperDetail(row.uuid).then((res) => {
        if (res && res.uuid) {
          this.form = { ...res };
          this.addbox = true;
        }
      });
    },
    delItem(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPaper(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    subForm() {
      if (this.form.paper_cate_id == "") {
        this.$message({
          type: "info",
          message: "请选择考卷分类",
        });
        return;
      }
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.form.uuid) {
            editPaper(this.form, this.form.uuid).then((res) => {
              console.log(res);
              if (res == true) {
                this.$message.success("成功");
                this.getList();
                this.closeForm();
              }
            });
          } else {
            addPaper(this.form).then((res) => {
              console.log(res);
              if (res == true) {
                this.$message.success("成功");
                this.getList();
                this.closeForm();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async getList() {
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        paper_cate_id: this.paper_cate_id,
        ...this.searchParam,
        exam_type: 1,
      };
      console.log(param);
      // return
      this.loading = true;
      const res = await paperList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
.add-form {
  max-height: 80vh;
  overflow: auto;
}
</style>
